import {getHours, getMinutes} from "date-fns";

export const isoDateTimeToTime = time => {
    let h = getHours(time);
    if (h === 0) h = '00';
    let m = getMinutes(time);
    if (m === 0) m = '00';
    return `${h}:${m}`;
}